import Vue from 'vue';
import App from './App.vue';
import VueMeta from 'vue-meta';
import router from './router';
import '@/assets/styles/main.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueMeta);
// 注意：Vue.use(VueRouter) 通常放在 src/router/index.js 中，所以这里不需要再写一次
Vue.config.productionTip = false;

new Vue({
  router, // <-- NEW: 将路由实例添加到根 Vue 实例中
  render: (h) => h(App),
}).$mount('#app');
